export type { IAnimationStyles, IAnimationVariables } from './IAnimationStyles';
export type { IGetFocusStylesOptions } from './IGetFocusStyles';
export type {
  IEffects,
  IFontStyles,
  IPalette,
  ISemanticColors,
  ISemanticTextColors,
  ISpacing,
  ITheme,
  IPartialTheme,
  IScheme,
  ISchemeNames,
} from '@fluentui/theme';
